module.exports = __webpack_public_path__ + "static/media/hero_blog_alt.58959416.svg";